import type { ResolvedWebsiteData } from "@rootreeweb/product-data";
import { resolvedWebsiteDataSchema as _resolvedWebsiteDataSchema } from "@rootreeweb/product-data";
import type { TranslationStore } from "@rootreeweb/react-translations";

export type AppContext = Omit<AppProps, "translations"> & {
	getLocalizedField: <T extends object>(data: T, field: string) => string;
};

export type AppProps = {
	languageSuffix: "EN" | "FR";
	links: Record<string, string>;
	pouches: PouchType[];
	rootPath: string;
	translations: Parameters<TranslationStore["setTranslations"]>[0];
};

export type Dieline = Size["dielines"][number];

export type FillOption = {
	hasAny: boolean;
	label: string;
};
export type PouchType = ResolvedWebsiteData;

export type Size = ResolvedWebsiteData["sizes"][number];
export const resolvedWebsiteDataSchema = _resolvedWebsiteDataSchema;
